import styled from "styled-components";

// Two-column responsive field grid for the inquiry form. Fields default to one
// column; a field marked `wide` spans both via `grid-column: 1 / -1`. Collapses
// to a single column on narrow viewports.
export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 18px;
  margin-bottom: 8px;

  @media (min-width: 560px) {
    grid-template-columns: 1fr 1fr;
  }
`;

// Editorial section divider between field groups (e.g. "The wedding").
export const SectionHeading = styled.h3`
  font-family: var(--jm-display);
  font-size: 22px;
  font-weight: 600;
  color: var(--jm-sage-deep);
  margin: 28px 0 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--jm-line);

  &:first-child {
    margin-top: 0;
  }
`;
